import QuizResults from './QuizResults';

export default QuizResults;
